import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
  static outlets = ['truck-gate-in--validations']
  /*
  Define targets for DOM elements that the controller interacts with to manage the Truck Gate In form:
  - emptyFields: Refers to the DOM element(s) containing fields displayed when the container status is "empty" (e.g., container ID, chassis, special instructions). Hidden and cleared when status is "full."
  - fullFields: Refers to the DOM element(s) containing fields displayed when the container status is "full" (e.g., booking ID, container ID, export release). Hidden and cleared when status is "empty."
  - statusContainer: Refers to the container holding the radio buttons for selecting container status ("full" or "empty"). Listens for changes to trigger the toggleContainerStatus method.
  - statusEmpty: A hidden input field storing the "empty" status value. Enabled when "empty" is selected, disabled when "full" is selected, ensuring the correct status is submitted.
  - statusFull: A hidden input field storing the "full" status value. Enabled when "full" is selected, disabled when "empty" is selected, ensuring the correct status is submitted.
  */
  static targets = [
    'emptyChassis',
    'emptyContainer',
    'emptyFields',
    'emptyGenset',
    'emptySpecialInstructions',
    'fullChassis',
    'fullContainer',
    'fullFields',
    'fullGenset',
    'fullSpecialInstructions',
    'statusContainer',
    'statusEmpty',
    'statusFull',
  ]

  connect() {
    if (this.hasStatusContainerTarget) {
      const selectedStatus = this.statusContainerTarget.querySelector('input[type="radio"]:checked')?.value
      if (selectedStatus) {
        this.toggleContainerStatus({ target: { value: selectedStatus } })
      } else {
        this.fullFieldsTarget.style.display = 'none'
        this.fullFieldsTarget.disabled = true
        this.emptyFieldsTarget.style.display = 'none'
        this.emptyFieldsTarget.disabled = true
      }
    }
  }

  // Toggles visibility and state of fields based on the selected container status
  toggleContainerStatus(event) {
    const status = event.target.value
    const fullFieldset = this.fullFieldsTarget
    const emptyFieldset = this.emptyFieldsTarget

    switch (status) {
      case "full":
        // First clear the now‑hidden side **before** we hide it
        this.clearFields(emptyFieldset)
        fullFieldset.style.display  = "block"
        fullFieldset.disabled       = false
        emptyFieldset.style.display = "none"
        emptyFieldset.disabled      = true
        this.truckGateInValidationsOutlets.forEach(panel =>
          panel.clearPresenceChecks('empty')
        )
        break
      case "empty":
        // First clear the now‑hidden side **before** we hide it
        this.clearFields(fullFieldset)
        fullFieldset.style.display  = "none"
        fullFieldset.disabled       = true
        emptyFieldset.style.display = "block"
        emptyFieldset.disabled      = false
        this.truckGateInValidationsOutlets.forEach(panel =>
          panel.clearPresenceChecks('full')
        )
        break
    }
  }

  // Clears all input fields within the specified container (except radio/checkbox inputs)
  clearFields(fieldset) {
    // Only fire change events when the fieldset was visible to the user.
    const wasVisible = fieldset.offsetParent !== null

    fieldset
      .querySelectorAll('input:not([type="radio"]):not([type="checkbox"]), select, textarea')
      .forEach(element => {
        // Reset value first
        element.value = ''

        if (element.tagName === 'SELECT' && $(element).data('select2')) {
          $(element).val(null) // clear Select2 value
          if (wasVisible) {
            $(element).trigger('change.select2') // only propagate when visible
          }
        } else if (wasVisible) {
          // Bubble a synthetic change *only* if the user could see the field
          element.dispatchEvent(new Event('change', { bubbles: true }))
        }
      })
  }

  handleContainerDropOffSelection(event) {
    const containerSelect = event.target;

    if (containerSelect === this.fullContainerTarget) {
      const data = $(this.fullContainerTarget).select2("data")[0];
      if (this.hasFullChassisTarget && data?.chassis_id) {
        const option = new Option(data.chassis_number, data.chassis_id, true, true);
        $(this.fullChassisTarget).empty().append(option).trigger('change.select2');
      }
      if (this.hasFullGensetTarget && data?.genset_id) {
        const option = new Option(data.genset_number, data.genset_id, true, true);
        $(this.fullGensetTarget).empty().append(option).trigger('change.select2');
      }
    } else if (containerSelect === this.emptyContainerTarget) {
      const data = $(this.emptyContainerTarget).select2("data")[0];
      if (this.hasEmptyChassisTarget && data?.chassis_id) {
        const option = new Option(data.chassis_number, data.chassis_id, true, true);
        $(this.emptyChassisTarget).empty().append(option).trigger('change.select2');
      }
      if (this.hasEmptyGensetTarget && data?.genset_id) {
        const option = new Option(data.genset_number, data.genset_id, true, true);
        $(this.emptyGensetTarget).empty().append(option).trigger('change.select2');
      }
    }
  }

  handleContainerDropOffClear(event) {
    const containerSelect = event.target;

    if (containerSelect === this.fullContainerTarget) {
      if (this.hasFullChassisTarget) {
        $(this.fullChassisTarget).val(null).trigger('change.select2');
      }
      if (this.hasFullGensetTarget) {
        $(this.fullGensetTarget).val(null).trigger('change.select2');
      }
    } else if (containerSelect === this.emptyContainerTarget) {
      if (this.hasEmptyChassisTarget) {
        $(this.emptyChassisTarget).val(null).trigger('change.select2');
      }
      if (this.hasFullGensetTarget) {
        $(this.fullGensetTarget).val(null).trigger('change.select2');
      }
    }
  }
}
